
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Pencil, Trash2, ArrowLeft, Printer } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getBrowserInfo } from '@/utils/printing/printingBridge';
import TeacherFormatDialog from '../TeacherFormatDialog';

interface TeacherHeaderActionsProps {
  id: string;
  teacherName?: string;
  onDelete: () => void;
  onPrint: (format: 'jpg' | 'pdf') => void;
}

export const TeacherHeaderActions = ({ id, teacherName, onDelete, onPrint }: TeacherHeaderActionsProps) => {
  const navigate = useNavigate();
  const [showFormatDialog, setShowFormatDialog] = useState(false);
  
  const handlePrintClick = () => {
    console.log('Print environment:', getBrowserInfo());
    setShowFormatDialog(true);
  };

  const handleFormatDownload = async (format: 'jpg' | 'pdf') => {
    try {
      await onPrint(format);
    } catch (error) {
      console.error('Error downloading teacher profile:', error);
    }
  };
  
  return (
    <>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sm:gap-0 mb-6">
        <Button 
          variant="outline" 
          onClick={() => navigate("/teachers")}
          className="w-full sm:w-auto"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Teachers
        </Button>
        <div className="flex gap-2 w-full sm:w-auto justify-end">
          <Button 
            variant="outline" 
            onClick={handlePrintClick}
            className="flex-1 sm:flex-grow-0"
            aria-label="Print teacher profile"
          >
            <Printer className="w-4 h-4 mr-2" />
            Print Profile
          </Button>
          <Button 
            variant="outline" 
            onClick={() => navigate(`/teachers/edit/${id}`)}
            className="flex-1 sm:flex-grow-0"
            aria-label="Edit teacher information"
          >
            <Pencil className="w-4 h-4 mr-2" />
            Edit
          </Button>
          <Button 
            variant="destructive" 
            onClick={onDelete}
            className="flex-1 sm:flex-grow-0"
            aria-label="Delete teacher"
          >
            <Trash2 className="w-4 h-4 mr-2" />
            Delete
          </Button>
        </div>
      </div>

      <TeacherFormatDialog
        isOpen={showFormatDialog}
        onClose={() => setShowFormatDialog(false)}
        onDownload={handleFormatDownload}
        downloadType="profile"
        teacherName={teacherName}
      />
    </>
  );
};
